/**
 * Ensures only one audio source plays at a time across the whole site.
 * AudioCard previews and the global MediaPlayer are two completely separate
 * systems with their own <audio> elements — without this, starting one
 * doesn't stop the other, so you can end up with two tracks playing at once.
 *
 * Usage: right before you actually start playback, call
 *   registerPlayback(() => myPauseFunction())
 * This stops whatever was previously playing (if it's a different source)
 * and remembers yours as the active one.
 */
let activeStop = null;

export function registerPlayback(stopFn) {
  if (activeStop && activeStop !== stopFn) {
    activeStop();
  }
  activeStop = stopFn;
}

export function clearPlayback(stopFn) {
  if (activeStop === stopFn) activeStop = null;
}
